<template>
  <div>
    <v-btn small fab color="white red--text" router to="/dashboard">
      <v-icon medium color="red">close</v-icon>
    </v-btn>
    <h2>Capacity Building Request for Human Rights Defenders</h2>
    <h3 v-if="!saved" class="grey darken-3 white--text pa-2">
      <v-btn small fab>
        <v-icon large class="grey--text">timelapse</v-icon>
      </v-btn>Requested level of Training to the defender
    </h3>
    <v-card class="pa-3">
      <v-form ref="form5" v-model="valid" lazy-validation>
        <v-flex xs12 wrap="true">
          <h2>
            <v-radio-group v-model="level" row>
              <v-radio
                class="teal--text"
                v-for="(colorValue, i) in ['Beginner', 'Intermediate', 'Advanced(Training of Trainers)']"
                :key="i"
                :color="color"
                :label="colorValue"
                :value="colorValue"
                :rules="[v => !!v || 'You must select type to continue!']"
              ></v-radio>
            </v-radio-group>
          </h2>
        </v-flex>
      </v-form>
    </v-card>
    <h3 v-if="!saved" class="grey darken-3 white--text pa-2">
      <v-btn small fab>
        <v-icon large class="grey--text">person_pin</v-icon>
      </v-btn>Contact Details and Location of the Proposed Trainee
      <v-card class="pa-3">
        <v-layout wrap>
          <v-flex xs12 md6>
            <v-form ref="form1" v-model="valid" lazy-validation>
              <v-text-field
                v-model="pname"
                label="Full Names:"
                prepend-icon="person"
                :rules="inputRules"
              ></v-text-field>
              <v-text-field
                v-model="pemail"
                label="Email Address:"
                prepend-icon="email"
                :rules="emailRules"
              ></v-text-field>
              <v-text-field
                v-model="pphone"
                label="Mobile No:"
                prepend-icon="phone"
                :rules="inputRules"
              ></v-text-field>
            </v-form>
          </v-flex>
          <v-flex xs12 md6>
            <v-form ref="form2" v-model="valid" lazy-validation>
              <v-text-field
                v-model="porg"
                label="Organisation name:"
                prepend-icon="business"
                :rules="inputRules"
              ></v-text-field>
              <v-text-field
                v-model="county"
                label="County of work"
                prepend-icon="location_on"
                :rules="inputRules"
              ></v-text-field>
              <v-text-field
                v-model="area"
                label="Town/Village where the HRDs works"
                prepend-icon="person_pin_circle"
                :rules="inputRules"
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card>
      <h3 class="grey darken-3 white--text pt-3">
        <v-btn small fab>
          <v-icon
            large
            class="indigo--text"
            @click="rdialog = true, additem='Human Rights'"
          >add_circle</v-icon>
        </v-btn>(Add the type of training if it is not available below) Base this on needs assesment and work of the defender
      </h3>
      <v-card class="pa-1">
        <v-form ref="form3" v-model="valid" lazy-validation>
          <h3 v-if="!saved">
            <v-dialog v-model="rdialog" max-width="400">
              <v-card class="pa-3">
                <v-card-title class="headline">New {{additem}} Category</v-card-title>
                <v-text-field
                  v-model="ttype"
                  :counter="50"
                  hint="Please only add if the new category does not match the list given on the form"
                  label="Add a new category"
                  required
                ></v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="green darken-1" @click="addCategory">Submit</v-btn>

                  <v-btn color="green darken-1" @click="rdialog = false">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </h3>
        </v-form>
      </v-card>
      <v-card class="pa-3">
        <v-form ref="form3" v-model="valid" lazy-validation>
          <v-layout row wrap="true">
            <v-divider></v-divider>
            <v-checkbox
              v-model="tcategory"
              v-for="selects in selected"
              :key="selects.id"
              :label="selects.category"
              :value="selects.category"
            ></v-checkbox>
          </v-layout>
          <v-divider></v-divider>
        </v-form>
      </v-card>
    </h3>
    <h3 v-if="!saved" class="grey darken-3 white--text pt-3">
      <v-btn small fab>
        <v-icon
          large
          class="indigo--text"
          @click="rdialog = true, additem='Human Rights'"
        >add_circle</v-icon>
      </v-btn>Select the Human Rights Issues/Themes the Defender works on (Add if missing)
      <v-card class="pa-3">
        <v-form ref="form4" v-model="valid" lazy-validation>
          <v-flex xs12 wrap="true">
            <v-layout wrap="true">
              <v-checkbox
                v-model="rcategory"
                v-for="rcatg in rights"
                :key="rcatg.id"
                :label="rcatg.category"
                :value="rcatg.category"
              ></v-checkbox>
            </v-layout>
          </v-flex>
        </v-form>
      </v-card>
    </h3>
    <v-container fluid class="grey lighten-1">
      <v-alert v-if="success" :value="true" color="green darken-5 white--text">
        <h3>Success: {{result}}</h3>
      </v-alert>
      <v-alert v-if="error" :value="true" color="red darken-4 white--text">
        <h3>Error: {{result}}</h3>
      </v-alert>
      <v-btn
        v-if="!saved"
        medium
        class="indigo darken-4 white--text"
        @click="submitTrainee"
        slot="activator"
      >
        <v-icon large>save</v-icon>
        <span>Submit Details</span>
      </v-btn>
      <v-btn v-if="saved" small color="indigo darken-4 white--text" @click="resetForm">
        <span>Suggest another Hrd</span>
        <v-icon medium right color="white">add_circle</v-icon>
      </v-btn>
      <v-btn fab small color="red darken-4" router to="/dashboard">
        <v-icon medium color="white">cancel</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>
<script>
import { db, auth, functions } from "@/fb";

export default {
  data() {
    return {
      //Main Details
      porg: "",
      pname: "",
      pemail: "",
      pphone: "",
      county: "",
      area: "",
      rcategory: [],
      tcategory: [],
      selected: [],
      level: "",
      rights: [],
      ttype: "",
      rdialog: false,
      //Setting for Control
      success: false,
      color: "",
      saved: false,
      error: false,
      result: "",
      additem: "",
      valid: true,
      stats: "",
      length: 0,
      id: 0,
      updateAction: "",
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 5 || "Minimum length is 3 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    //Get edit details if not new
    var option = this.$route.params.ref;
    // console.log(option);
    if (option != "" && typeof option != "undefined") {
      this.updateAction == true;
      //Get data from the database
      db.collection("hrds4training").onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            if (option == change.doc.id) {
              this.porg = change.doc.data().p_org;
              this.pname = change.doc.data().p_name;
              this.pemail = change.doc.data().p_email;
              this.pphone = change.doc.data().p_phone;
              this.county = change.doc.data().county;
              this.area = change.doc.data().area;
              this.level = change.doc.data().level;
              this.rcategory = change.doc.data().category;
              this.tcategory = change.doc.data().theme;
            }
          }
        });
      });
    } else {
      this.updateAction == false;
    }

    //Display Training Categories
    db.collection("t_categories").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.selected.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
    //Dispay Human Rights Categories
    db.collection("r_categories").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.rights.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  },
  methods: {
    resetForm() {
      this.saved = false;
      this.success = false;
      this.wrong = false;
    },
    submitTrainee() {
      if (this.$refs.form1.validate() && this.$refs.form2.validate()) {
        if (this.level != "") {
          if (this.tcategory != "") {
            if (this.rcategory != "") {
              if ((this.updateAction = false)) {
                //ADD NEW HRD FOR TRAINING
                db.collection("hrds4training")
                  .doc()
                  .set({
                    p_name: this.pname,
                    p_phone: this.pphone,
                    p_email: this.pemail,
                    p_org: this.porg,
                    county: this.county,
                    area: this.area,
                    theme: this.rcategory,
                    level: this.level,
                    category: this.tcategory
                  })
                  .then(() => {
                    this.wrong = false;
                    this.result =
                      "The HRD has been successfully submited for future consideration";
                    this.saved = true;
                    this.success = true;
                    this.docuid,
                      //RESET
                      (this.pname = "");
                    this.pphone = "";
                    this.pemail = "";
                    this.porg = "";
                    this.county = "";
                    this.area = "";
                    this.rcategory = "";
                    this.tcategory = "";
                    this.level = "";
                    //router.push({ path: 'projects' })
                  })
                  .catch(error => {
                    // Handle Errors here.
                    this.wrong = true;
                    this.success = false;
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.error = errorMessage + " (" + errorCode + ")";
                  });
              } else {
                //EDIT DETAILS OF HRD TO BE TRAINED
                db.collection("hrds4training")
                  .doc(this.$route.params.ref)
                  .update({
                    p_name: this.pname,
                    p_phone: this.pphone,
                    p_email: this.pemail,
                    p_org: this.porg,
                    county: this.county,
                    area: this.area,
                    theme: this.rcategory,
                    level: this.level,
                    category: this.tcategory
                  })
                  .then(() => {
                    this.wrong = false;
                    this.result = "Update was successful";
                    this.saved = true;
                    this.success = true;
                    this.docuid,
                      //RESET
                      (this.pname = "");
                    this.pphone = "";
                    this.pemail = "";
                    this.porg = "";
                    this.county = "";
                    this.area = "";
                    this.rcategory = "";
                    this.tcategory = "";
                    this.level = "";
                    //router.push({ path: 'projects' })
                  });
              }
            } else {
              this.error = true;
              this.result = "Please select human rights work of the HRDS";
            }
          } else {
            this.error = true;
            this.result = "Please select the training recommended for the HRD";
          }
        } else {
          this.error = true;
          this.result =
            "Please select the appropriate level of training of the HRD";
        }
      } else {
        this.error = true;
        this.success = false;
        this.result = "Please enter or select all the required information";
      }
    },
    addCategory() {
      var catg = "";
      if (this.additem == "Human Rights") {
        catg = "r_categories";
      }
      if (this.additem == "Training") {
        catg = "t_categories";
      }
      if (this.ttype != "") {
        db.collection(catg)
          .doc()
          .set({
            category: this.ttype
          })
          .then(() => {
            this.rdialog = false;
            this.ttype = "";
          });
      }
    }
  }
};
</script>